import React, { useState, useEffect } from 'react';
import { Col, Grid, Row, Button } from 'react-bootstrap';
import GroupPatients from './GroupPatients';
import GroupPatientForm from './GroupPatientForm';
import GroupPractitionerForm from './GroupPractitionerForm';
import GroupPractitionerList from './GroupPractitionerList';
import PractitionerPatientAssignment from './PractitionerPatient';
import Card from '../../Cards/Card';
import { useTranslation } from 'react-i18next'
import { IconSVG, ViewMR } from '../../Icons/Icons';
import { CustomSelect } from '../../CustomControls/CustomSelect';
import { ModalData } from '../../Modals/ModalData';
import { ErrorMessage, Formik } from 'formik';
import { ControlLabel, FormControl } from 'react-bootstrap';
import { FormErrorMessage } from '../../Validations/FormValidationErrors';
import { SnomedPicker } from '../../CustomControls/SnomedPicker';
import { snomedExpressions } from '../../../variables/Enums';
import { Add, Save } from '../../Icons/Icons';
import { groupValidations } from './GroupValidations';

const GroupDetail = ({ onBack, patientsProp, practitionersProp, patientsPractitionerProp, group, editGroupButton, deleteAllPractitionersButton, deleteAllPatientsButton, AddPractitionersButton, deletePractitionerButton, deletePatientButton, addPatientsButton, handleProtocolChange, selectProtocolComponent }) => {
    const { t } = useTranslation();

    return (
        <>
            <Card
                header={
                    <>  
                        <Row>
                            <Col md={6}>
                                <button className={`btn btn-primary btn-fill`} onClick={onBack}>
                                    <IconSVG name="back" /> {t('buttons.back')}
                                </button>
                            </Col>
                            <Col md={3} >
                                {selectProtocolComponent}
                            </Col>
                            <Col md={3} className="text-right">
                                {editGroupButton}
                            </Col>
                        </Row>
                    </>

                }
                content={
                    <>
                        <div>
                            <Grid fluid>
                                <Row>
                                    <Col md={6}>
                                        <Card
                                            header={
                                                <>
                                                    <GroupPractitionerForm
                                                        props={practitionersProp}
                                                        deleteAllPractitionersButton={deleteAllPractitionersButton}
                                                        AddPractitionersButton={AddPractitionersButton}
                                                    />
                                                </>
                                            }
                                            content={
                                                <>
                                                    <GroupPractitionerList
                                                        propsPractitioners={practitionersProp}
                                                        patientsPractitionerProp={patientsPractitionerProp}
                                                        deletePractitionerButton={deletePractitionerButton }
                                                    />
                                                </>
                                            }
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <Card
                                            header={
                                                <>
                                                    <GroupPatientForm
                                                        props={patientsProp}
                                                        deleteAllPatientsButton={deleteAllPatientsButton}
                                                        addPatientsButton={addPatientsButton }
                                                    />
                                                </>
                                            }
                                            content={
                                                <>
                                                    <GroupPatients
                                                        props={patientsProp}
                                                        deletePatientButton={deletePatientButton}
                                                    />
                                                </>
                                            }
                                        />
                                    </Col>
                                </Row>
                            </Grid>
                        </div>
                    </>
                }
            />            
        </>

    );
};

export default GroupDetail;